import { appOverride } from '@util/AppUtils';
import { trackFlowEnteredAnalytics } from '@util/FlowUtils';
import { useEnsureCurrentPageMatchesPayFlow } from '@util/UseEnsureCurrentPageMatchesPayFlow';
import React, { FunctionComponent, useEffect } from 'react';
import styled from 'styled-components';
import { isDefined } from 'ts-utils';
import { Color } from '../../config/Color';
import { PAY_CONFIG } from '../../config/PayConfig';
import { useAppStore } from '../../store/Store';
import '../../theme.less';
import { animations } from '../assets/Animations';
import { PreloadFlowImages } from '../assets/preloadFlowImages/PreloadFlowImages';
import { FlowStack } from '../flows/FlowStack';

export const Pay: FunctionComponent = () => {
  const flowConfig = PAY_CONFIG;
  const purchase = useAppStore((state) => state.purchase);
  const background = appOverride({ nerva: animations.nervaBackground, default: undefined });
  const isCurrentPageInPayFlow = useEnsureCurrentPageMatchesPayFlow();

  useEffect(function trackAnalyticsEvent() {
    trackFlowEnteredAnalytics(purchase, PAY_CONFIG.name);
  }, []);

  if (!isCurrentPageInPayFlow) {
    return null;
  }

  return (
    <Backdrop color={Color.surface.default}>
      {isDefined(background) && <Background src={background} alt="" />}
      <ContentWrapper>
        <PreloadFlowImages flowConfig={flowConfig} />
        <FlowStack config={flowConfig} />
      </ContentWrapper>
    </Backdrop>
  );
};

type BackdropProps = {
  color: string;
};

const Backdrop = styled.div<BackdropProps>`
  position: relative;
  height: 100%;
  min-height: 100vh;
  background: ${({ color }) => color};
  transition: 0.3s background-color ease-in-out;
  overflow: hidden;
`;

const Background = styled.img`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  pointer-events: none;
  object-fit: cover;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  height: 100%;
  min-height: 100vh;
`;
